export enum CommonClasses {
  ActionButton = 'action-button',
  TooltipChangeVisibilityPoint = 'tooltip-change-visibility-point',
}
